// extracted by mini-css-extract-plugin
module.exports = {"indicator":"environment_indicator_indicator__tXDwS"};